//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'VRS',
  data() {
    return {
      form: {
        item: '0',
      },
      itemList: [
        { value: '1', name: '无痛' },
        { value: '2', name: '轻度，虽有疼痛，但可以忍受，睡眠不受干扰，能正常生活' },
        { value: '3', name: '中度，疼痛明显，不能忍受，要求止痛，睡眠受干扰' },
        { value: '4', name: '重度，剧烈疼痛可伴有植物神经功能紊乱表现，或被动体位，严重干扰睡眠' },
        { value: '5', name: '极度，患者所想象的最严重的疼痛' },
      ],
      hasScore: false,
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.item
      console.log(result);
      self.hasScore = true
      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/VRS.vue